import React, { ElementType, ReactNode } from "react";
import { SxProps } from "@mui/material";
import { Theme } from "@emotion/react";
import Grid from '@mui/material/Grid';

interface GridProps {
    component: ElementType;
    sx?: SxProps<Theme>;
    children?: ReactNode
}

const GridComponent = (props: GridProps) => {
    return <Grid container spacing={2}>
        {props.children}
    </Grid>
}

export default GridComponent;